import { LineOfCreditTransactionView } from '@varo/graphql-schema-types';
import { parse } from 'date-fns';
import { LineOfCreditTransactionInput } from 'features/lineOfCredit/screens/activeDetailsScreen/ActiveDetailsScreen';

const mapToTransactionDetails = ({
  transaction,
}: LineOfCreditTransactionInput): LineOfCreditTransactionView => {
  const accountDetailsArray =
    transaction.onClick?.transaction?.detailsR2?.flatMap((detail) =>
      detail?.items.map(({ title, value }) => ({ title, value })),
    );

  const getDetailValue = (title: string) =>
    accountDetailsArray?.find((item) => item.title === title)?.value || '';

  const accountFrom = getDetailValue('From account');
  const accountTo = getDetailValue('To account');
  const description = getDetailValue('Description');
  const status = getDetailValue('Status');
  const requestedOnDate = getDetailValue('Requested on');

  const parsedDate =
    requestedOnDate !== ''
      ? parse(requestedOnDate, 'MMMM dd, yyyy', new Date())
      : '';

  return {
    accountFrom: accountFrom,
    accountTo: accountTo,
    description: description,
    status: status,
    amount: {
      amount: transaction.primaryDetail?.copy,
      currency: '$',
      formatted: transaction.primaryDetail?.copy || '',
      formattedWithPlusPrefix: transaction.primaryDetail?.copy || '',
      formattedWithPlusPrefixOrAbs: '',
    },
    date: parsedDate.toString(),
    runningBalance: {
      amount: transaction.secondaryDetail?.copy || '',
      currency: '$',
      formatted: transaction.secondaryDetail?.copy || '',
      formattedWithPlusPrefix: transaction.secondaryDetail?.copy || '',
      formattedWithPlusPrefixOrAbs: '',
    },
  };
};

export default mapToTransactionDetails;
